import * as React from 'react';
import { FormGroup, FormControlLabel } from "../../../theme/MUIImports"
import { CustomSwitch } from './CustomSwitch';

export const CustomizedSwitches = ({ checked, handleCheck }) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={<CustomSwitch label={{ yes: "Approve", no: "Deny" }} checked={checked} onChange={handleCheck} />}
      />
    </FormGroup>
  );
}